<template>
  <div>
    <div id="AchievementChange" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modal.AchievementName }} - {{ modal.AchievementIndex }}</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">انتخاب فایل exel</label>
                <div class="col-lg-9">
                  <input
                    type="number"
                    class="form-control"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    v-model="modal.prize"
                  />
                  <!-- <div class="group material-input"> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-shadow" data-dismiss="modal">
                بستن
              </button>
              <button type="submit" class="btn btn-primary" @click="handleClick">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modal: {},
  },

  watch: {
    modal(newValue, oldValue) {
      console.log(newValue), console.log(oldValue);
    },
  },
  methods: {
    handleClick() {
      this.$emit('clicked', this.modal);
    },
  },
};
</script>
